import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import { isMobile } from "react-device-detect";

//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  Temperatura: "automaticStationsTemperature",
};

//Componente Temperatura
class Temperature extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      temperature: "noneLayerTemperatura",
      temperatureData: [],
      symbology: [],
    };
  }

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyStationsData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });
    this.createRender();

    this.setState({
      temperatureData: [],
    });
  };

  //Abre nueva ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Dibuja los puntos en el mapa
  drawPoints = () => {
    const { temperatureData } = this.state;

    var cdmxExtent = new this.props.esri.Extent({
      xmax: -98.409,
      xmin: -99.889,
      ymax: 19.649,
      ymin: 18.894,
      spatialReference: new this.props.esri.SpatialReference(4326),
    });
    var features = [];

    temperatureData.forEach((station) => {
      var longitude = parseFloat(station.longitud);
      var latitude = parseFloat(station.latitud);
      var temperatura = parseFloat(station["temperatura"]).toFixed(2);
      var point = new this.props.esri.Point(longitude, latitude);
      if (!cdmxExtent.contains(point)) return;

      var graphic = new this.props.esri.Graphic(point);
      var attributes = {
        nombreEstacion: station.estacion_m,
        organismo: station.organismo,
        estado: station.estado,
        municipio: station.municipio,
        fechaLocal: station.fecha_local,
        fechaUTC: station.fecha_utc,
        temperatura: temperatura,
      };
      graphic.setAttributes(attributes);

      var infoTemplateJson = {
        title: station.estacion_m,
        content:
          "<b>Organismo: </b> " +
          station.organismo +
          "<br>" +
          "<b>Estado: </b> " +
          station.estado +
          "<br>" +
          "<b>Municipio: </b> " +
          station.municipio +
          "<br>" +
          "<b>Fecha Local Centro: </b> " +
          station.fecha_local +
          " hrs<br>" +
          "<b>Fecha UTC: </b> " +
          station.fecha_utc +
          " hrs<br>" +
          "<b>Latitud:</b> " +
          latitude.toFixed(5) +
          " <br>" +
          "<b>Longitud:</b> " +
          longitude.toFixed(5) +
          "<br>" +
          "<b>Temperatura:</b> " +
          temperatura +
          " ºC<br>",
      };
      graphic.setInfoTemplate(
        new this.props.esri.InfoTemplate(infoTemplateJson)
      );
      features.push(graphic);
    });

    if (this.props.mapView.getLayer(layerNames.Temperatura)) {
      this.props.mapView
        .getLayer(layerNames.Temperatura)
        .applyEdits(features, null, null);
    }

    this.createRender();
  };

  //Crea el render con las opciones de imagen para los puntos en el mapa
  createRender = () => {
    var width = 20;
    var height = 20;
    var layer = this.props.mapView.getLayer(layerNames.Temperatura);

    var rendererField = "temperatura";

    var renderer = new this.props.esri.ClassBreaksRenderer(null, rendererField);
    var baseURL = "./imgs/Temperatura/";

    var hastaMenos17_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m20_m17_5.png",
      width,
      height
    );
    var hastaMenos15 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m17_5_m15.png",
      width,
      height
    );
    var hastaMenos12_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m15_m12_5.png",
      width,
      height
    );
    var hastaMenos10 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m12_5_m10.png",
      width,
      height
    );
    var hastaMenos7_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m10_m7_5.png",
      width,
      height
    );
    var hastaMenos5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m7_5_m5.png",
      width,
      height
    );
    var hastaMenos2_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m5_m2_5.png",
      width,
      height
    );
    var hastaMas0 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "m2_5_0.png",
      width,
      height
    );
    var hastaMas2_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "0_2_5.png",
      width,
      height
    );
    var hastaMas5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "2_5_5.png",
      width,
      height
    );
    var hastaMas7_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "5_7_5.png",
      width,
      height
    );
    var hastaMas10 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "7_5_10.png",
      width,
      height
    );
    var hastaMas12_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "10_12_5.png",
      width,
      height
    );
    var hastaMas15 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "12_5_15.png",
      width,
      height
    );
    var hastaMas17_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "15_17_5.png",
      width,
      height
    );
    var hastaMas20 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "17_5_20.png",
      width,
      height
    );
    var hastaMas22_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "20_22_5.png",
      width,
      height
    );
    var hastaMas25 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "22_5_25.png",
      width,
      height
    );
    var hastaMas27_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "25_27_5.png",
      width,
      height
    );
    var hastaMas30 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "27_5_30.png",
      width,
      height
    );
    var hastaMas32_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "30_32_5.png",
      width,
      height
    );
    var hastaMas35 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "32_5_35.png",
      width,
      height
    );
    var hastaMas37_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "35_37_5.png",
      width,
      height
    );
    var hastaMas40 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "37_5_40.png",
      width,
      height
    );
    var hastaMas42_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "40_42_5.png",
      width,
      height
    );
    var hastaMas45 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "42_5_45.png",
      width,
      height
    );
    var hastaMas47_5 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "45_47_5.png",
      width,
      height
    );
    var hastaMas50 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "47_5_50.png",
      width,
      height
    );
    var mas50 = new this.props.esri.PictureMarkerSymbol(
      baseURL + "50_mas.png",
      width,
      height
    );

    renderer.addBreak(-20, -17.5, hastaMenos17_5);
    renderer.addBreak(-17.5, -15, hastaMenos15);
    renderer.addBreak(-15, -12.5, hastaMenos12_5);
    renderer.addBreak(-12.5, -10, hastaMenos10);
    renderer.addBreak(-10, -7.5, hastaMenos7_5);
    renderer.addBreak(-7.5, -5, hastaMenos5);
    renderer.addBreak(-5, -2.5, hastaMenos2_5);
    renderer.addBreak(-2.5, 0, hastaMas0);
    renderer.addBreak(0, 2.5, hastaMas2_5);
    renderer.addBreak(2.5, 5, hastaMas5);
    renderer.addBreak(5, 7.5, hastaMas7_5);
    renderer.addBreak(7.5, 10, hastaMas10);
    renderer.addBreak(10, 12.5, hastaMas12_5);
    renderer.addBreak(12.5, 15, hastaMas15);
    renderer.addBreak(15, 17.5, hastaMas17_5);
    renderer.addBreak(17.5, 20, hastaMas20);
    renderer.addBreak(20, 22.5, hastaMas22_5);
    renderer.addBreak(22.5, 25, hastaMas25);
    renderer.addBreak(25, 27.5, hastaMas27_5);
    renderer.addBreak(27.5, 30, hastaMas30);
    renderer.addBreak(30, 32.5, hastaMas32_5);
    renderer.addBreak(32.5, 35, hastaMas35);
    renderer.addBreak(35, 37.5, hastaMas37_5);
    renderer.addBreak(37.5, 40, hastaMas40);
    renderer.addBreak(40, 42.5, hastaMas42_5);
    renderer.addBreak(42.5, 45, hastaMas45);
    renderer.addBreak(45, 47.5, hastaMas47_5);
    renderer.addBreak(47.5, 50, hastaMas50);
    renderer.addBreak(50, 100, mas50);

    layer.setRenderer(renderer);
    layer.redraw();

    let symbols = [];
    symbols.push({ min: -20, max: -17.5, url: hastaMenos17_5.url });
    symbols.push({ min: -17.5, max: -15, url: hastaMenos15.url });
    symbols.push({ min: -15, max: -12.5, url: hastaMenos12_5.url });
    symbols.push({ min: -12.5, max: -10, url: hastaMenos10.url });
    symbols.push({ min: -10, max: -7.5, url: hastaMenos7_5.url });
    symbols.push({ min: -7.5, max: -5, url: hastaMenos5.url });
    symbols.push({ min: -5, max: -2.5, url: hastaMenos2_5.url });
    symbols.push({ min: -2.5, max: 0, url: hastaMas0.url });
    symbols.push({ min: 0, max: 2.5, url: hastaMas2_5.url });
    symbols.push({ min: 2.5, max: 5, url: hastaMas5.url });
    symbols.push({ min: 5, max: 7.5, url: hastaMas7_5.url });
    symbols.push({ min: 7.5, max: 10, url: hastaMas10.url });
    symbols.push({ min: 10, max: 12.5, url: hastaMas12_5.url });
    symbols.push({ min: 12.5, max: 15, url: hastaMas15.url });
    symbols.push({ min: 15, max: 17.5, url: hastaMas17_5.url });
    symbols.push({ min: 17.5, max: 20, url: hastaMas20.url });
    symbols.push({ min: 20, max: 22.5, url: hastaMas22_5.url });
    symbols.push({ min: 22.5, max: 25, url: hastaMas25.url });
    symbols.push({ min: 25, max: 27.5, url: hastaMas27_5.url });
    symbols.push({ min: 27.5, max: 30, url: hastaMas30.url });
    symbols.push({ min: 30, max: 32.5, url: hastaMas32_5.url });
    symbols.push({ min: 32.5, max: 35, url: hastaMas35.url });
    symbols.push({ min: 35, max: 37.5, url: hastaMas37_5.url });
    symbols.push({ min: 37.5, max: 40, url: hastaMas40.url });
    symbols.push({ min: 40, max: 42.5, url: hastaMas42_5.url });
    symbols.push({ min: 42.5, max: 45, url: hastaMas45.url });
    symbols.push({ min: 45, max: 47.5, url: hastaMas47_5.url });
    symbols.push({ min: 47.5, max: 50, url: hastaMas50.url });
    //symbols.push({ min: 50, max: 100, url: mas50.url });
    this.setState({ symbology: symbols });
  };

  //Obtiene losdatos del serivicio de Tempratura acumulada
  getStationsValues = async (period) => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Temperatura
    );
    var radarUrl = `${proxieURL}${layer.url.replace("$period", period)}`;
    const res = await fetch(radarUrl, {
      method: "GET",
    }).catch((err) => {
      this.getDummyStationsData();
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.json();

        this.setState(
          {
            temperatureData: data,
          },
          () => {
            this.drawPoints();
          }
        );
      } else {
        this.getDummyStationsData();
      }
    }
  };

  //Maneja los eventos de cambio de estado del los controles option box
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === "temperature") {
        let layer = this.props.mapView.getLayer(layerNames.Temperatura);
        layer.setVisibility(value !== "noneLayerTemperatura");
        if (value !== "noneLayerTemperatura") {
          this.getStationsValues(value);
        }
      }
    });
  };

  //Render del componente inicial
  render() {
    const { temperature, symbology } = this.state;
    let idx = 0;

    return (
      <Box style={{ width: "100%" }}>
        <Box align="center" mb={1}>
          <a
            href="https://smn.conagua.gob.mx/es/observando-el-tiempo/estaciones-meteorologicas-automaticas-ema-s"
            color="primary"
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="caption">(SMN)</Typography>
          </a>
        </Box>

        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <Box component={Paper} p={1}>
              <FormControl component="fieldset" size="small">
                {/* <FormLabel component="legend"></FormLabel> */}
                <RadioGroup
                  aria-label="temperature"
                  name="temperature"
                  value={temperature}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value="T30"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="caption">
                        Últimos 30 minutos
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="T1"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="caption">Última hora</Typography>
                    }
                  />
                  <FormControlLabel
                    value="T2"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="caption">Últimas 2 horas</Typography>
                    }
                  />
                  <FormControlLabel
                    value="T3"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="caption">Últimas 3 horas</Typography>
                    }
                  />
                  <FormControlLabel
                    value="T4"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="caption">
                        Últimas 24 horas
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="noneLayerTemperatura"
                    control={<Radio size="small" />}
                    label={<Typography variant="caption">Ninguno</Typography>}
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="simple table">
                <TableBody>
                  {isMobile && symbology.length > 0 && (
                    <Box m={1}>
                      <Typography variant="subtitle2">Simbología</Typography>
                    </Box>
                  )}
                  {symbology.map((row) => (
                    <TableRow key={idx++}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ width: 20, paddingRight: 0 }}
                      >
                        <img
                          alt="simbologia"
                          src={row.url}
                          style={{ width: 20 }}
                        ></img>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Typography variant="caption" display="inline">
                          <Box mr={1}></Box>
                          De {row.min}ºC a {row.max}ºC
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withSnackbar(Temperature);
